import MuiDialog from "@mui/material/Dialog";
import { DialogContent } from "@mui/material";
import { useDialog } from "../../../context/dialog/DialogContext";
import { isValidElement, cloneElement } from "react";
import { styled } from "@mui/material/styles";
import MuiDialogTitle from "@mui/material/DialogTitle";

import { IconButton, Typography } from '@mui/material';
import iconLibrary from '../../../constans/icons';

const DialogTitle = styled(MuiDialogTitle)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: 500,
  fontSize: "1.25rem",
  backgroundColor: 'rgb(239, 243, 251)',
  padding: theme.spacing(2),
  borderBottom: `1px solid ${theme.palette.divider}`,
  color: theme.palette.text.primary,
}));

const Dialog = () => {
  const { dialogStack } = useDialog();

  return (
    <>
      {dialogStack.map((dialog) => {
        const { id, title, content, maxWidth, fullScreen, close } = dialog;

        const contentWithClose = isValidElement(content)
          ? cloneElement(content, { close })
          : content;

        return (
          <MuiDialog
            key={id}
            open={true}
            onClose={() => close(null)}
            maxWidth={maxWidth}
            fullWidth
            fullScreen={fullScreen}
          >
<DialogTitle>
  <Typography variant="h6" component="div" sx={{ flex: 1, textAlign: "center" }}>
{title}
  </Typography>
  <IconButton
    aria-label="close"
    onClick={() => close(null)}
    sx={{
      position: "absolute",
      right: 8,
      top: 8,
      color: (theme) => theme.palette.grey[500],
    }}
  >
{iconLibrary.cancel}  

</IconButton>
</DialogTitle>
            <DialogContent
              dividers
              sx={{
                padding: 3,
                backgroundColor: "white",
                fontSize: "0.95rem",
              }}
            >
              {contentWithClose}
            </DialogContent>
          </MuiDialog>
        );
      })}
    </>
  );
};

export default Dialog;
